import React from 'react';
import { useCollectionStateContext } from 'Context/CollectionStateContext';
import {
  FDStack,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import {
  AuthenticationFactorListItem,
} from 'Organisms/AuthenticationFactorList/AuthenticationFactorListItemRevamp/AuthenticationFactorListItem';
import AuthFactorModal from '../AuthFactorModal';


const AuthenticationFactorList = ({ onMount }) => {
  const { collection } = useCollectionStateContext();

  const authFactorResources = collection.resources().list();

  const authFactorIncludedResources = collection?.included();

  React.useEffect(() => {
    onMount(collection);
  }, []);

  return (
    <FDStack direction={'column'} spacing={0}>
      <FDStack direction={'column'} spacing={4}>
        {authFactorResources.map((res) => (
          <AuthenticationFactorListItem
            key={res.attr('authenticationType')}
            authenticationFactorResource={res}
            authFactorIncludedResources={authFactorIncludedResources}
          />
        ))}
      </FDStack>
      <AuthFactorModal />
    </FDStack>
  );
};

AuthenticationFactorList.defaultProps = {
  onMount: () => {},
};

AuthenticationFactorList.propTypes = {
  onMount: PropTypes.func,
};

export default AuthenticationFactorList;
